import React from 'react';
import { useTranslation } from 'react-i18next';

const RestrictedVisitModal = ({ visit, onClose }) => {
    const { t } = useTranslation();

    if (!visit) {
        return null;
    }

    const formatDate = (date) => {
        if (!date) return '---';
        return new Date(date).toLocaleString();
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.6)',
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '90%',
                    maxWidth: '600px',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    padding: '24px'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600 }}>
                        {visit.type === 'inpatient'
                            ? t('receptionInpatients.title', { defaultValue: 'Inpatient Visit' })
                            : t('receptionOutpatients.title', { defaultValue: 'Outpatient Visit' })}
                        {visit.serial_num ? ` #${visit.serial_num}` : ''}
                    </h3>
                    <button
                        onClick={onClose}
                        style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}
                        aria-label={t('common.close', { defaultValue: 'Close' })}
                    >
                        ×
                    </button>
                </div>

                <div style={{ display: 'grid', gap: '10px', marginBottom: '20px' }}>
                    <InfoRow label={t('common.date', { defaultValue: 'Date' })} value={formatDate(visit.visit_date || visit.created_at)} />
                    <InfoRow label={t('common.status', { defaultValue: 'Status' })} value={visit.status || '---'} />
                    {visit.reason && (
                        <InfoRow label={t('receptionOutpatients.details.reason', { defaultValue: 'Reason' })} value={visit.reason} />
                    )}
                    <InfoRow label={t('common.vet', { defaultValue: 'Veterinarian' })} value={visit.doctor_name || '---'} />
                    {visit.clinic_name && (
                        <InfoRow label={t('common.clinic', { defaultValue: 'Clinic' })} value={visit.clinic_name} />
                    )}
                </div>

                <div style={{ backgroundColor: '#F3F4F6', borderRadius: '8px', padding: '16px' }}>
                    <h4 style={{ margin: '0 0 8px 0', fontSize: '1rem', fontWeight: 600 }}>
                        {t('common.finalDiagnosis', { defaultValue: 'Final Diagnosis' })}
                    </h4>
                    <p style={{ margin: 0, color: '#374151', whiteSpace: 'pre-wrap' }}>
                        {visit.final_diagnosis || '---'}
                    </p>
                </div>
            </div>
        </div>
    );
};

const InfoRow = ({ label, value }) => (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 600, color: '#6B7280', minWidth: '120px' }}>{label}:</span>
        <span style={{ color: '#111827', flex: 1 }}>{value}</span>
    </div>
);

export default RestrictedVisitModal;
